import { createI18n } from 'vue-i18n'
import enGB from '@/locales/en-gb.json'
import deDe from '@/locales/de-de.json'
import roRo from '@/locales/ro-ro.json'
import esES from '@/locales/es-es.json'
import frFR from '@/locales/fr-fr.json'
import itIT from '@/locales/it-it.json'
import nlNL from '@/locales/nl-nl.json'

const currentLocale = localStorage.getItem('fpt-user-locale') || 'en-gb'

const i18n = createI18n({
  locale: currentLocale,
  fallbackLocale: 'en-gb',
  allowComposition: true,
  legacy: false,
  globalInjection: true,
  messages: {
    "en-gb": enGB,
    "de-de": deDe,
    "nl-nl": nlNL,
    "es-es": esES,
    "fr-fr": frFR,
    "it-it": itIT,
    "ro-ro": roRo
  }
})

export default i18n
